// Note that there is no "attribute" API, but this is a collection of clients that work together to form this client.
import { retrieveRequiredVariables } from 'src/services/surfaceClient';
import { AttributeRulesResult } from 'src/types/services';
import { RenderingSDK } from '@rendering/web-client';
export const clientId = 'L7F3LDeQMgZf9J2smpD1c10N2NaNlkP5';
export function retrieveRuleData(sdk: RenderingSDK, sku: string) {
    return sdk.Products.getRulesData(sku).then((res) => res);
}

export function retrieveAllAndRequiredVariables(
    sdk: RenderingSDK,
    sku: string,
    version: string | number | undefined,
): Promise<AttributeRulesResult> {
    const numericVersion = typeof version === 'string' ? parseInt(version, 10) : version;
    if (!numericVersion) {
        return Promise.reject(new Error(`skuVersion is required to load rules, sku=${sku}`));
    }
    const rulePromise = retrieveRuleData(sdk, sku);
    const requiredVariablePromise = retrieveRequiredVariables(sdk, sku, numericVersion);
    return Promise.all([rulePromise, requiredVariablePromise]).then(([ruleSet, requiredVariablesRaw]) => {
        const requiredVariables = requiredVariablesRaw || [];
        // Special flag, if couldn't find required variables then flag for merchandising only
        const merchandisingOnly = requiredVariablesRaw === undefined;
        return { requiredVariables, ruleSet, merchandisingOnly };
    });
}
